// extracted by mini-css-extract-plugin
export default {"link":"QK-z","disabled":"RK-z"};